import { NgModule } from '@angular/core';
import { BaseModule } from '../shared/base.module';
import { NotificationsComponent } from './notifications.component';
import { NotificationsRoutesModule } from './notifications.routes';
import { NotificationModule } from '../shared/notification/notification.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NotificationDetailsComponent } from './details/details.component';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogModule } from '../dialog/dialog.module';
import { PaginationModule } from '../shared/pagination/pagination.module';
import { SharedPopoverModule } from '../shared/popover/popover.module';
import { MATERIALS } from '../app.materials';

//ngx-bootstrap modules
import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import {CollapseModule} from "ngx-bootstrap/collapse";
import {AccordionModule} from "ngx-bootstrap/accordion";
import {TabsModule} from "ngx-bootstrap/tabs";
import {ModalModule} from "ngx-bootstrap/modal";
import {PopoverModule} from "ngx-bootstrap/popover";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import { BreadcrumbModule } from '../shared/breadcrumb/breadcrumb.module';

@NgModule({
    imports: [
        MATERIALS,
        BaseModule,
        DialogModule,
        NotificationsRoutesModule,
        NotificationModule,
        PerfectScrollbarModule,
        PaginationModule,
        SharedPopoverModule,
        AccordionModule.forRoot(),
        BsDropdownModule.forRoot(),
        CollapseModule.forRoot(),
        TabsModule.forRoot(),
        ModalModule.forRoot(),
        PopoverModule.forRoot(),
        TooltipModule.forRoot(),
        BreadcrumbModule
    ],
    declarations: [
        NotificationsComponent,
        NotificationDetailsComponent
    ],
    entryComponents: [
        DialogComponent
    ]
})

export class NotificationsModule {
}
